import React, { useContext, useRef } from 'react';

import { List, Paper, Popper } from '@mui/material';
import PropTypes from 'prop-types';

import { PopperPlacementType } from 'constants/popover';

import ContextMenuContext from './ContextMenuContext';
import ContextMenuItem from './ContextMenuItem';
import { subMenuPopperStyles } from './ContextMenuSubMenu.styles';

const contextMenuItemPopperOptions = {
  placement: PopperPlacementType.RIGHT_START,
};

const ContextMenuSubMenu = ({
  id,
  label,
  isDisabled = false,
  icon = null,
  children,
  ...restProps
}) => {
  const { selectedItemId, onSelectMenuItem } = useContext(ContextMenuContext);
  const itemRef = useRef();
  const isSelected = selectedItemId === id;

  return (
    <>
      <ContextMenuItem
        {...restProps}
        data-id={id}
        icon={icon}
        isDisabled={isDisabled}
        isSubMenuItem={!!children}
        label={label}
        ref={itemRef}
        selected={isSelected}
        onMouseEnter={onSelectMenuItem}
      />

      <Popper
        anchorEl={itemRef.current}
        open={isSelected}
        popperOptions={contextMenuItemPopperOptions}
        sx={subMenuPopperStyles}
      >
        <List disablePadding component={Paper}>
          {children}
        </List>
      </Popper>
    </>
  );
};

ContextMenuSubMenu.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  icon: PropTypes.elementType,
  isDisabled: PropTypes.bool,
};

export default ContextMenuSubMenu;
